<template>
  <div>
    <div class="p-box surveyTemplateForm">
      <div class="topSpace">
        <div class="c-button c-button--right">
          <router-link class="c-button__item c-button__item--outline-cancel" :to="{ name: 'CompaniesSurveys', params: { companyUuid: companyUuid } }">
            {{ $t('components.CompaniesSurveyTemplateForm.backToIndex') }}
          </router-link>
        </div>
      </div>
      <div class="p-box surveyTemplateForm__box">
        <ValidationObserver ref="companiesCustomSurveyForm" v-slot="{ handleSubmit }" tag="">
          <form>
            <div class="p-box__header">
              <div class="p-filtersA">
                <div class="p-filtersA__left">
                  <ul class="c-links">
                    <li
                      v-for="menu in menus"
                      :key="menu"
                      class="c-links__item"
                    >
                      <strong
                        :class="selectedMenu === menu && 'is-current'"
                        @click="clickMenu(menu)"
                      >
                        {{ $t('components.CompaniesSurveyTemplateForm.tabs.' + menu ) }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <div class="p-filtersA__right">
                  <div class="c-button c-button--right">
                    <router-link class="c-button__item c-button__item--outline-cancel" :to="{ name: 'CompaniesSurveys', params: { companyUuid: companyUuid } }">
                      {{ $t('labels.cancel') }}
                    </router-link>
                    <button class="c-button__item c-button__item--primary" type="button" @click="handleSubmit($event, onSubmit)">
                      {{ $t('labels.save') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-box__body">
              <Loading v-if="loading" />
              <template v-else>
                <ValidationObserver ref="companiesCustomSurveyFormBasic" tag="">
                  <CompaniesSurveyTemplateFormBasic
                    v-show="selectedMenu === 'basic'"
                  />
                </ValidationObserver>
                <ValidationObserver ref="companiesCustomSurveyFormQuestion" tag="">
                  <CompaniesSurveyTemplateFormQuestion
                    v-show="selectedMenu === 'question'"
                  />
                </ValidationObserver>
                <ValidationObserver ref="companiesCustomSurveyFormComplete" tag="">
                  <CompaniesSurveyTemplateFormComplete
                    v-show="selectedMenu === 'complete'"
                  />
                </ValidationObserver>
              </template>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CompaniesSurveyTemplateFormBasic from '../../components/CompaniesSurveyTemplateForm/Basic'
import CompaniesSurveyTemplateFormQuestion from '../../components/CompaniesSurveyTemplateForm/Question'
import CompaniesSurveyTemplateFormComplete from '../../components/CompaniesSurveyTemplateForm/Complete'
import Loading from '../../components/Loading'
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'SurveyTemplateForm',
  components: {
    Loading,
    CompaniesSurveyTemplateFormQuestion,
    CompaniesSurveyTemplateFormBasic,
    CompaniesSurveyTemplateFormComplete
  },
  data() {
    return {
      selectedMenu: 'basic',
    }
  },
  computed: {
    ...mapState({
      loading: state => state.companiesCustomSurvey.loading,
      formData: state => state.companiesCustomSurvey.data,
      meta: state => state.companiesCustomSurvey.meta,
      tmpMediaImages: state => state.companiesMediaImage.images,
      customSurveyBrands: state => state.companiesPublishingCustomSurveyBrands.data,
      selectedBrandIds: state => state.companiesCustomSurvey.data.brand.brandIds,
    }),
    isCopyPage() {
      return this.$route.query.copySurveyId != null
    },
    companyUuid() {
      return this.$route.params.company_uuid
    },
    menus: () => ['basic', 'question', 'complete'],
    isEditPage() {
      return !!this.$route.params.survey_id
    },
    questionsExceptNps() {
      return this.formData.question.questions.map((v, i) => {
        v.position = i + 1
        if (v.questionType !== 'radio' && v.questionType !== 'checkbox') {
          delete v.options
        }
        return v
      })
    },
    modifiedStatus() {
      let status = this.meta.status
      if (this.formData.basic.changePublishState) {
        status = this.meta.status === 'published' ? 'closed' : 'published'
      }
      return status
    },
    nps() {
      const nps = cloneDeep(this.formData.question.nps)
      nps.position = this.questionsExceptNps.length + 1
      return nps
    },
    otherBrandIds() {
      const surveyId = this.$route.params.survey_id
      if (surveyId) {
        const otherCustomSurveyBrands = this.customSurveyBrands.filter((value) => value.customSurveyId !== Number(surveyId))
        return otherCustomSurveyBrands.map(b => b.brandId)
      } else {
        return this.customSurveyBrands.map(b => b.brandId)
      }
    },
    hasSameSelectBrands() {
      if(this.selectedBrandIds.length === 0 || this.otherBrandIds.length === 0) return false
      return this.otherBrandIds.filter(otherId => this.selectedBrandIds.includes(otherId)).length > 0
    },
    canShowAlertPublicState() {
      if (this.meta.status === 'unpublished' && this.formData.basic.changePublishState) {
        return true
      } else if (this.meta.status === 'published' && !this.formData.basic.changePublishState) {
        return true
      }
      return false
    },
  },
  async created() {
    if (this.isEditPage) {
      this.readCustomSurvey(this.$route.params.survey_id)
      return
    }
    this.resetCustomSurvey()
    if (this.isCopyPage) {
      await this.readCustomSurvey(this.$route.query.copySurveyId)
      this.changeDataForCopy()
    }
  },
  methods: {
    ...mapActions({
      readCustomSurvey: 'companiesCustomSurvey/readCustomSurvey',
      createCustomSurvey: 'companiesCustomSurvey/createCustomSurvey',
      updateCustomSurvey: 'companiesCustomSurvey/updateCustomSurvey',
      resetCustomSurvey: 'companiesCustomSurvey/resetCustomSurvey',
      changeCustomSurveyForCopy: 'companiesCustomSurvey/changeCustomSurveyForCopy',
      changeAttribute: 'companiesCustomSurvey/changeAttribute',
      uploadMediaImages: 'companiesMediaImage/uploadMediaImages',
      resetMediaImages: 'companiesMediaImage/resetMediaImages',
    }),
    async getMediaImage({ name, url }) {
      return await fetch(url, {
        mode: 'cors'
      })
        .then(res => res.blob())
        .then(res => new File([res], name, {
          type: res.type
        }))
    },
    async changeDataForCopy() {
      this.changeCustomSurveyForCopy()

      const basicCoverImage = this.formData.basic.mediaImage
      const completeCoverImage = this.formData.complete.mediaImage
      if (basicCoverImage) {
        const basicCoverImageFile = await this.getMediaImage({ name: basicCoverImage.name, url: basicCoverImage.url })
        await this.uploadMediaImages([basicCoverImageFile])
        this.changeAttribute({ tab: 'basic', key: 'mediaImage', value: this.tmpMediaImages[0] })
        this.resetMediaImages()
      }
      if (completeCoverImage) {
        const completeCoverImageFile = await this.getMediaImage({ name: completeCoverImage.name, url: completeCoverImage.url })
        await this.uploadMediaImages([completeCoverImageFile])
        this.changeAttribute({ tab: 'complete', key: 'mediaImage', value: this.tmpMediaImages[0] })
        this.resetMediaImages()
      }
    },
    clickMenu(menu) {
      this.selectedMenu = menu
    },
    async validate() {
      const basicSuccess = await this.$refs.companiesCustomSurveyFormBasic.validate()
      if (!basicSuccess.valid) {
        alert(this.$t('components.CompaniesSurveyTemplateForm.validationError.basic'))
        return false
      }
      const questionSuccess = await this.$refs.companiesCustomSurveyFormQuestion.validate()
      if (!questionSuccess.valid) {
        alert(this.$t('components.CompaniesSurveyTemplateForm.validationError.question'))
        return false
      }
      const completeSuccess = await this.$refs.companiesCustomSurveyFormComplete.validate()
      if (!completeSuccess.valid) {
        alert(this.$t('components.CompaniesSurveyTemplateForm.validationError.complete'))
        return false
      }
      if (this.meta.status === 'published' && this.formData.basic.changePublishState) {
        if (!confirm(this.$t('components.CompaniesSurveyTemplateForm.confirm'))) {
          return false
        }
      }
      return true
    },
    async onSubmit() {
      const isValid = await this.validate()
      if (!isValid) return
      if (this.selectedBrandIds.length === 0 && this.canShowAlertPublicState) {
        if (!confirm(this.$t('components.CompaniesSurveyTemplateForm.basic.brand.noBrandConfirm'))) {
          return
        }
      }
      if (this.hasSameSelectBrands && this.canShowAlertPublicState) {
        if (!confirm(this.$t('components.CompaniesSurveyTemplateForm.basic.brand.duplicateConfirm'))) {
          return
        }
      }
      const data = {
        basicInfo: {
          name: this.formData.basic.templateName
        },
        question: {
          items: this.questionsExceptNps
        },
        complete: {
          title: this.formData.complete.title,
          description: this.formData.complete.text,
          mediaImageId: this.formData.complete.mediaImage?.id
        },
        guideToReviewSite: this.formData.guideToReviewSite,
        status: this.modifiedStatus,
        brandIds: this.formData.brand.brandIds
      }
      if (this.formData.basic.showEmailForm) {
        data.basicInfo.answererEmailSetting = {
          supportEmail: this.formData.basic.supportEmail,
          required: this.formData.basic.requiredEmail,
          privacy_policy_body: this.formData.basic.showPrivacyPolicyForm ? this.formData.basic.privacyPolicyBody : '',
        }
      }
      if (this.formData.basic.showCoverForm) {
        data.basicInfo.cover = {
          title: this.formData.basic.coverTitle,
          description: this.formData.basic.coverText,
          mediaImageId: this.formData.basic.mediaImage?.id
        }
      }
      if (this.formData.complete.showBtnForm) {
        data.complete.button = {
          label: this.formData.complete.btnLabel,
          link: this.formData.complete.btnLink,
        }
      }
      if (this.formData.question.showNps) {
        data.question.items.push(this.nps)
      }
      if (!this.meta.questionEditable) delete data.question
      if (this.isEditPage) {
        await this.updateCustomSurvey(data)
        if (this.meta.status === 'closed') {
          this.$router.push({ name: 'CompaniesSurveys', params: { company_uuid: this.companyUuid } })
        }
      } else {
        const id = await this.createCustomSurvey(data)
        this.$router.push({ name: 'CompaniesSurveysEdit', params: { company_uuid: this.companyUuid, survey_id: id } })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.surveyTemplateForm {
  padding: 32px;
  &__box {
    border: 1px solid #E4E7EB;
  }
}
</style>
